import axios from 'axios';
import config from 'config';
import { authHeader } from '../_helpers/auth-header';
import { clearSession } from '../_helpers/session';

let unauthorizedHandler = null;

export const apiClient = axios.create({
  baseURL: config.apiUrl,
});

apiClient.interceptors.request.use((requestConfig) => {
  const headers = authHeader();

  if (headers.Authorization) {
    requestConfig.headers = {
      ...requestConfig.headers,
      ...headers,
    };
  }

  return requestConfig;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearSession();

      if (unauthorizedHandler) {
        unauthorizedHandler(error);
      }
    }

    return Promise.reject(error);
  }
);

export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = handler;
}

export function getApiErrorMessage(error) {
  const detail = error?.response?.data?.detail;
  const message = error?.message;

  if (detail) {
    return detail;
  }

  if (typeof error?.response?.data === 'string') {
    return error.response.data;
  }

  if (message) {
    return message;
  }

  return 'Unexpected error';
}
